import { render, staticRenderFns } from "./CategoryTotals.vue?vue&type=template&id=81f796e4&"
import script from "./CategoryTotals.vue?vue&type=script&lang=js&"
export * from "./CategoryTotals.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTotals.vue?vue&type=style&index=0&id=81f796e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports